module.exports = __webpack_public_path__ + "static/media/2.be95f015.jpg";